"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinigolfCreaturesData = exports.createEnemy = exports.createParticle = exports.createPickup = exports.createBlock = exports.createMisc = exports.DefaultMinigolfCreatureData = void 0;
var diveColors_1 = require("@dive/colors/diveColors");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var minigolfColors_1 = require("../defs/minigolfColors");
var minigolfColors_sidecar_1 = require("../defs/minigolfColors-sidecar");
var minigolfDefs_1 = require("../defs/minigolfDefs");
var minigolfSounds_sidecar_1 = require("../sound/minigolfSounds-sidecar");
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var standardScale = (78 / 121) * 1.6;
var puckScale = 78 / 121;
exports.DefaultMinigolfCreatureData = {
    ai: '',
    creatureType: '',
    damageMessage: '',
    density: 1,
    frames: [],
    hasDisc: false,
    hasHealth: false,
    imageScale: standardScale,
    isFixed: false,
    isPuck: false,
    isMimic: false,
    isSensor: false,
    isTrap: false,
    isSpike: false,
    isEnemy: false,
    isParticle: false,
    isAnimatedTile: false,
    isBreakable: false,
    isAffectedBySlopes: false,
    isBlock: false,
    letter: '',
    letterOffset: 0,
    letterOffsetY: 0,
    maxHealth: 0,
    moveStrength: 0,
    name: '',
    pickupType: '',
    shape: 'circle',
    roundedShape: false,
    renderOrder: 0,
    size: 1,
    physicsSizeScale: 1,
    enemyPoints: 0,
    enemyDifficulty: 0,
    dropChance: 0,
    canBreakCrates: false,
    damagedSayings: [],
    colorDisc: minigolfColors_sidecar_1.minigolfColors.MinigolfColors[0].tint,
    colorLetter: diveColors_1.diveColors.darkBlue,
    colorAlpha: 1,
    contactSounds: [],
    hitBySounds: [],
    onDeath: '',
    collisionGroups: minigolfDefs_1.CollisionGroups.groundAndFlying,
    bleeds: '',
    autoDoom: 0,
    hasTorch: false,
};
var create = function (partialDataDefault, partialData) {
    return __assign(__assign(__assign({}, exports.DefaultMinigolfCreatureData), partialDataDefault), partialData);
};
var createMisc = function (partialData) {
    return create({}, partialData);
};
exports.createMisc = createMisc;
var createBlock = function (partialData) {
    return create({
        hasDisc: false,
        isFixed: true,
        isBlock: true,
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitBlock],
        collisionGroups: minigolfDefs_1.CollisionGroups.all,
        // roundedShape: true,
        physicsSizeScale: 1.05,
    }, partialData);
};
exports.createBlock = createBlock;
var createPickup = function (partialData) {
    return create({
        hasDisc: true,
        isSensor: false,
        renderOrder: -1,
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playPickup],
        collisionGroups: minigolfDefs_1.CollisionGroups.ground,
    }, partialData);
};
exports.createPickup = createPickup;
var createParticle = function (partialData) {
    return create({
        density: 0.05,
        renderOrder: -2,
        contactSounds: [],
        collisionGroups: minigolfDefs_1.CollisionGroups.particle,
        isParticle: true,
    }, partialData);
};
exports.createParticle = createParticle;
var createEnemy = function (partialData) {
    return create({
        hasDisc: true,
        enemyPoints: 1,
        isEnemy: true,
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitEnemy],
        collisionGroups: minigolfDefs_1.CollisionGroups.ground,
    }, partialData);
};
exports.createEnemy = createEnemy;
exports.MinigolfCreaturesData = {
    playerPuck: exports.createMisc({
        density: 1,
        frames: sprites_sidecar_1.sprites.minigolfPlayer,
        creatureType: 'puck',
        imageScale: puckScale,
        isPuck: true,
        hasDisc: true,
        renderOrder: 10,
        isAffectedBySlopes: true,
        canBreakCrates: true,
        bleeds: 'blood',
    }),
    stairsDown: exports.createMisc({
        shape: 'square',
        frames: sprites_sidecar_1.sprites.minigolfStairsDown,
        isSensor: true,
        pickupType: 'stairs-down',
        isFixed: true,
    }),
    stairsUp: exports.createMisc({
        shape: 'square',
        frames: sprites_sidecar_1.sprites.minigolfStairsUp,
        isSensor: true,
        pickupType: 'stairs-up',
        isFixed: true,
    }),
    particleBlood: exports.createParticle({
        frames: sprites_sidecar_1.sprites.minigolfParticleBlood,
    }),
    particleSlime: exports.createParticle({
        frames: sprites_sidecar_1.sprites.minigolfParticleSlime,
    }),
    particleWood: exports.createParticle({
        frames: sprites_sidecar_1.sprites.minigolfParticleWood,
    }),
    particleSpectral: exports.createParticle({
        frames: sprites_sidecar_1.sprites.minigolfParticleSpectral,
    }),
    particleLava: exports.createParticle({
        frames: sprites_sidecar_1.sprites.minigolfParticleLava,
        // autoDoom: 2,
    }),
    particleDust: exports.createParticle({
        frames: sprites_sidecar_1.sprites.minigolfParticleDust,
        autoDoom: 0.5,
    }),
    particleStar: exports.createParticle({
        frames: sprites_sidecar_1.sprites.minigolfParticleStar,
        autoDoom: 0.75,
    }),
    bonusFood: exports.createPickup({
        frames: sprites_sidecar_1.sprites.minigolfMeat,
        pickupType: 'food',
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playEat],
    }),
    bonusHealth: exports.createPickup({
        frames: sprites_sidecar_1.sprites.minigolfHeartHalf,
        pickupType: 'health',
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playPickupHeart],
    }),
    bonusHealth2: exports.createPickup({
        frames: sprites_sidecar_1.sprites.minigolfHeart,
        pickupType: 'health2',
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playPickupHeart],
    }),
    bonusSword: exports.createPickup({
        frames: sprites_sidecar_1.sprites.minigolfSword,
        pickupType: 'sword',
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playPickupSword],
    }),
    bonusKey: exports.createPickup({
        frames: sprites_sidecar_1.sprites.minigolfKey,
        pickupType: 'key',
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playPickupKey],
    }),
    bonusAmulet: exports.createPickup({
        frames: sprites_sidecar_1.sprites.minigolfAmulet,
        pickupType: 'amulet',
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playPickupAmulet],
    }),
    bonusMoney: exports.createPickup({
        frames: sprites_sidecar_1.sprites.minigolfMoney,
        pickupType: 'money',
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playPickupAmulet],
        size: 0.75,
        hasDisc: false,
    }),
    bonusWeb: exports.createPickup({
        // frames: sprites.minigolfAmulet,
        letter: 'w',
        letterOffset: -5,
        name: 'Web',
        pickupType: 'web',
        ai: '',
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playPickupWeb],
        colorDisc: minigolfColors_1.palApollo.gray500,
        colorLetter: minigolfColors_1.palApollo.gray900,
        bleeds: 'spectral',
    }),
    blockTriangle: exports.createBlock({
        density: 150,
        shape: 'triangle',
        frames: sprites_sidecar_1.sprites.minigolfTriangle,
    }),
    blockTriangleBroken: exports.createBlock({
        density: 12.5,
        shape: 'triangle',
        frames: sprites_sidecar_1.sprites.minigolfTriangle,
        isFixed: false,
    }),
    blockSquare: exports.createBlock({
        density: 150,
        shape: 'square',
        frames: sprites_sidecar_1.sprites.minigolfWall,
    }),
    blockSquareBroken: exports.createBlock({
        density: 12.5,
        shape: 'square',
        frames: sprites_sidecar_1.sprites.minigolfWall,
        isFixed: false,
    }),
    blockSquareCombinedH: exports.createBlock({
        density: 150,
        shape: 'square',
        frames: minigolfDefs_sidecar_1.minigolfDefs.debug_combinedWalls
            ? sprites_sidecar_1.sprites.minigolfWallCombinedH
            : sprites_sidecar_1.sprites.minigolfWall,
        collisionGroups: minigolfDefs_1.CollisionGroups.none,
    }),
    blockSquareCombinedV: exports.createBlock({
        density: 150,
        shape: 'square',
        frames: minigolfDefs_sidecar_1.minigolfDefs.debug_combinedWalls
            ? sprites_sidecar_1.sprites.minigolfWallCombinedV
            : sprites_sidecar_1.sprites.minigolfWall,
        collisionGroups: minigolfDefs_1.CollisionGroups.none,
    }),
    blockSquareTorch: exports.createBlock({
        density: 150,
        shape: 'square',
        frames: __spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.minigolfBlockTorch)), __read(sprites_sidecar_1.sprites.minigolfBlockTorch2)), __read(sprites_sidecar_1.sprites.minigolfBlockTorch3)),
        isAnimatedTile: true,
        hasTorch: true,
    }),
    blockSquareTorchCombined: exports.createBlock({
        density: 150,
        shape: 'square',
        frames: minigolfDefs_sidecar_1.minigolfDefs.debug_combinedWalls
            ? __spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.minigolfWallCombinedV)), __read(sprites_sidecar_1.sprites.minigolfWallCombinedH)) : __spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.minigolfBlockTorch)), __read(sprites_sidecar_1.sprites.minigolfBlockTorch2)), __read(sprites_sidecar_1.sprites.minigolfBlockTorch3)),
        isAnimatedTile: true,
        hasTorch: true,
        collisionGroups: minigolfDefs_1.CollisionGroups.none,
    }),
    blockSquareTorchBroken: exports.createBlock({
        density: 12.5,
        shape: 'square',
        frames: __spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.minigolfBlockTorch)), __read(sprites_sidecar_1.sprites.minigolfBlockTorch2)), __read(sprites_sidecar_1.sprites.minigolfBlockTorch3)),
        isAnimatedTile: true,
        isFixed: false,
        hasTorch: true,
    }),
    blockPillar: exports.createBlock({
        density: 150,
        shape: 'circle',
        frames: __spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.minigolfPillarTorch1)), __read(sprites_sidecar_1.sprites.minigolfPillarTorch2)), __read(sprites_sidecar_1.sprites.minigolfPillarTorch3)),
        isAnimatedTile: true,
        hasTorch: true,
    }),
    blockPillarBroken: exports.createBlock({
        density: 25,
        shape: 'circle',
        frames: __spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.minigolfPillarTorch1)), __read(sprites_sidecar_1.sprites.minigolfPillarTorch2)), __read(sprites_sidecar_1.sprites.minigolfPillarTorch3)),
        isAnimatedTile: true,
        hasTorch: true,
        isFixed: false,
    }),
    crate: exports.createMisc({
        density: 5,
        imageScale: standardScale,
        maxHealth: 2,
        hasHealth: false,
        hasDisc: false,
        shape: 'square',
        frames: __spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.minigolfCrate)), __read(sprites_sidecar_1.sprites.minigolfCrateSmashed)),
        ai: '',
        isSensor: false,
        pickupType: '',
        isFixed: false,
        isAffectedBySlopes: true,
        isBreakable: true,
        creatureType: 'crate',
        dropChance: 0.75,
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playCrateHit],
        collisionGroups: minigolfDefs_1.CollisionGroups.ground,
        bleeds: 'wood',
        //dropChance: 1,
    }),
    doorLocked: exports.createMisc({
        isFixed: true,
        isSensor: false,
        creatureType: 'lock',
        shape: 'square',
        frames: sprites_sidecar_1.sprites.minigolfLock,
        size: 2.5,
    }),
    doorLockedBroken: exports.createMisc({
        density: 25,
        isFixed: false,
        isSensor: false,
        creatureType: 'lock',
        shape: 'square',
        frames: sprites_sidecar_1.sprites.minigolfLock,
        size: 2,
    }),
    spikeSquare: exports.createMisc({
        density: 2.5,
        imageScale: standardScale,
        hasDisc: false,
        shape: 'square',
        frames: sprites_sidecar_1.sprites.minigolfSpikeSquare,
        isFixed: false,
        isTrap: true,
        isSpike: true,
        creatureType: 'spike',
        isAffectedBySlopes: true,
        enemyDifficulty: 3,
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitSpike],
        collisionGroups: minigolfDefs_1.CollisionGroups.ground,
    }),
    lava: exports.createMisc({
        density: 2.5,
        imageScale: standardScale,
        hasDisc: false,
        shape: 'square',
        isAnimatedTile: true,
        frames: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.minigolfLava1)), __read(sprites_sidecar_1.sprites.minigolfLava2)), __read(sprites_sidecar_1.sprites.minigolfLava3)), __read(sprites_sidecar_1.sprites.minigolfLava2)),
        isSensor: true,
        isFixed: true,
        isTrap: true,
        creatureType: 'lava',
        renderOrder: -10,
        enemyDifficulty: 6,
        collisionGroups: minigolfDefs_1.CollisionGroups.ground,
        bleeds: 'lava',
    }),
    slimePool: exports.createMisc({
        density: 2.5,
        imageScale: standardScale,
        hasDisc: false,
        shape: 'square',
        isAnimatedTile: true,
        frames: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(sprites_sidecar_1.sprites.minigolfSlime1)), __read(sprites_sidecar_1.sprites.minigolfSlime2)), __read(sprites_sidecar_1.sprites.minigolfSlime3)), __read(sprites_sidecar_1.sprites.minigolfSlime2)),
        isSensor: true,
        isFixed: true,
        isTrap: true,
        creatureType: 'slime',
        renderOrder: -10,
        enemyDifficulty: 0,
        collisionGroups: minigolfDefs_1.CollisionGroups.ground,
        bleeds: 'slime',
    }),
    slope: exports.createMisc({
        density: 2.5,
        imageScale: standardScale,
        hasDisc: false,
        shape: 'square',
        frames: sprites_sidecar_1.sprites.minigolfFloorSlopeWe,
        isSensor: true,
        isFixed: true,
        isTrap: false,
        creatureType: 'slope',
        renderOrder: -5,
        collisionGroups: minigolfDefs_1.CollisionGroups.ground,
    }),
    slope2: exports.createMisc({
        density: 2.5,
        imageScale: standardScale,
        hasDisc: false,
        shape: 'square',
        frames: sprites_sidecar_1.sprites.minigolfFloorSlope2,
        isSensor: true,
        isFixed: true,
        isTrap: false,
        creatureType: 'slope2',
        renderOrder: -5,
        collisionGroups: minigolfDefs_1.CollisionGroups.ground,
    }),
    enemyBat: exports.createEnemy({
        density: 0.25,
        imageScale: standardScale,
        maxHealth: 1,
        hasHealth: true,
        hasDisc: true,
        shape: 'circle',
        frames: sprites_sidecar_1.sprites.minigolfCreatureBat,
        ai: 'random',
        damageMessage: 'bat bite',
        creatureType: 'bat',
        name: 'Bat',
        letter: 'b',
        moveStrength: 1,
        isAffectedBySlopes: false,
        enemyDifficulty: 1,
        enemyPoints: 1,
        damagedSayings: ['screech', 'flap', 'flutter'],
        colorDisc: minigolfColors_1.palApollo.pink200,
        colorLetter: minigolfColors_1.palApollo.blue300,
        hitBySounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitByBat],
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitBat],
        collisionGroups: minigolfDefs_1.CollisionGroups.flying,
        bleeds: 'blood',
        dropChance: 0.25,
        onDeath: 'drop-item-lesser',
    }),
    enemyJelly: exports.createEnemy({
        density: 2,
        imageScale: standardScale,
        maxHealth: 1,
        hasHealth: true,
        hasDisc: true,
        shape: 'circle',
        frames: sprites_sidecar_1.sprites.minigolfCrate,
        ai: 'wait',
        isSensor: true,
        damageMessage: 'jellied',
        creatureType: 'jelly',
        name: 'Jelly',
        letter: 'j',
        moveStrength: 0.25,
        isAffectedBySlopes: false,
        enemyDifficulty: 2,
        enemyPoints: 1,
        damagedSayings: ['squish', 'glorp', 'slurp', 'gloop'],
        colorDisc: minigolfColors_1.palApollo.green500,
        colorLetter: minigolfColors_1.palApollo.green200,
        hitBySounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitJelly],
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitJelly],
        bleeds: 'slime',
    }),
    enemyBlob: exports.createEnemy({
        density: 5,
        imageScale: standardScale,
        maxHealth: 1,
        hasHealth: true,
        hasDisc: true,
        shape: 'circle',
        frames: sprites_sidecar_1.sprites.minigolfCreatureBat,
        ai: 'random',
        damageMessage: 'slimed',
        creatureType: 'blob',
        name: 'Blob',
        letter: 'B',
        letterOffset: -7,
        moveStrength: 0.33,
        isAffectedBySlopes: true,
        enemyDifficulty: 3,
        enemyPoints: 1,
        damagedSayings: ['boing!', 'blobob', 'wobble-wobble', 'jiggle'],
        colorDisc: minigolfColors_1.palApollo.green300,
        colorLetter: minigolfColors_1.palApollo.green100,
        hitBySounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitBlob],
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitBlob],
        onDeath: 'spawn-blob-mini',
        bleeds: 'slime',
    }),
    enemyBlobMini: exports.createEnemy({
        density: 5,
        imageScale: standardScale,
        maxHealth: 1,
        hasHealth: true,
        hasDisc: true,
        shape: 'circle',
        frames: sprites_sidecar_1.sprites.minigolfCreatureBat,
        ai: 'random',
        damageMessage: 'slimed',
        creatureType: 'blob',
        name: 'Blob',
        letter: 'B',
        letterOffset: 0,
        moveStrength: 0.33,
        isAffectedBySlopes: true,
        enemyDifficulty: 3,
        enemyPoints: 1,
        damagedSayings: ['boing!', 'blobob', 'wobble-wobble', 'jiggle'],
        colorDisc: minigolfColors_1.palApollo.green300,
        colorLetter: minigolfColors_1.palApollo.green100,
        hitBySounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitBlob],
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitBlob],
        size: 0.75,
        bleeds: 'slime',
    }),
    enemyRat: exports.createEnemy({
        density: 0.5,
        maxHealth: 1,
        hasHealth: true,
        hasDisc: true,
        shape: 'circle',
        frames: sprites_sidecar_1.sprites.minigolfCrate,
        ai: 'chase-player',
        damageMessage: 'nibbled on',
        creatureType: 'rat',
        name: 'Rat',
        letter: 'r',
        moveStrength: 0.33,
        isAffectedBySlopes: true,
        enemyDifficulty: 4,
        enemyPoints: 2,
        canBreakCrates: true,
        damagedSayings: ['squeak', 'chitter'],
        colorDisc: minigolfColors_1.palApollo.brown200,
        colorLetter: minigolfColors_1.palApollo.brown500,
        hitBySounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitByRat],
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitRat],
        bleeds: 'blood',
        dropChance: 0.25,
        onDeath: 'drop-item-lesser',
    }),
    enemyGhost: exports.createEnemy({
        density: 1,
        imageScale: standardScale,
        maxHealth: 1,
        hasHealth: false,
        hasDisc: true,
        shape: 'circle',
        frames: sprites_sidecar_1.sprites.minigolfCreatureBat,
        ai: 'chase-random-entity',
        isSensor: true,
        damageMessage: 'haunted',
        creatureType: 'ghost',
        name: 'Ghost',
        letter: 'G',
        moveStrength: 0.25,
        letterOffset: -5,
        isAffectedBySlopes: false,
        enemyDifficulty: 5,
        enemyPoints: 1,
        damagedSayings: ['wooooo', 'spooky', 'rattle', 'moan'],
        colorDisc: minigolfColors_1.palApollo.gray500,
        colorLetter: minigolfColors_1.palApollo.gray200,
        colorAlpha: 0.5,
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitGhost],
        bleeds: 'spectral',
    }),
    enemyWraith: exports.createEnemy({
        density: 1,
        imageScale: standardScale,
        maxHealth: 1,
        hasHealth: false,
        hasDisc: true,
        shape: 'circle',
        frames: sprites_sidecar_1.sprites.minigolfCreatureBat,
        ai: 'chase-player',
        isSensor: true,
        damageMessage: 'haunted',
        creatureType: 'ghost',
        name: 'Wraith',
        letter: 'W',
        moveStrength: 0.25,
        letterOffset: -7,
        isAffectedBySlopes: false,
        enemyDifficulty: 8,
        enemyPoints: 3,
        damagedSayings: ['wooooo', 'spooky', 'rattle', 'moan'],
        colorDisc: minigolfColors_1.palApollo.gray300,
        colorLetter: minigolfColors_1.palApollo.gray600,
        colorAlpha: 0.5,
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitWraith],
        bleeds: 'spectral',
    }),
    enemyMimic: exports.createEnemy({
        density: 5,
        imageScale: standardScale,
        maxHealth: 4,
        hasHealth: true,
        hasDisc: false,
        shape: 'square',
        frames: sprites_sidecar_1.sprites.minigolfCrate,
        ai: 'chase-player',
        damageMessage: 'splintered',
        creatureType: 'mimic',
        name: 'Mimic',
        isMimic: true,
        // letter: 'M',
        moveStrength: 0.25,
        isAffectedBySlopes: true,
        enemyDifficulty: 6,
        enemyPoints: 2,
        damagedSayings: ['chomp', 'gnash', 'crunch', 'gobble'],
        hitBySounds: [minigolfSounds_sidecar_1.minigolfSounds.playCrateHit],
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playCrateHit],
        onDeath: 'drop-item',
        dropChance: 1,
        bleeds: 'wood',
    }),
    enemyGoblin: exports.createEnemy({
        density: 3,
        maxHealth: 2,
        hasHealth: true,
        hasDisc: true,
        shape: 'circle',
        frames: sprites_sidecar_1.sprites.minigolfCrate,
        ai: 'chase-player',
        damageMessage: 'gobbled',
        creatureType: 'goblin',
        name: 'Gobin',
        letter: 'g',
        letterOffset: -3,
        letterOffsetY: -6,
        moveStrength: 1,
        isAffectedBySlopes: true,
        enemyDifficulty: 7,
        enemyPoints: 3,
        canBreakCrates: true,
        size: 1.25,
        damagedSayings: ['grr', 'argh', 'snarl', 'growl'],
        colorDisc: minigolfColors_1.palApollo.brown200,
        colorLetter: minigolfColors_1.palApollo.green500,
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitGoblin],
        hitBySounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitByGoblin],
        onDeath: 'drop-item',
        dropChance: 0.75,
        bleeds: 'blood',
    }),
    enemySpider: exports.createEnemy({
        density: 1,
        maxHealth: 3,
        hasHealth: true,
        hasDisc: true,
        shape: 'circle',
        frames: sprites_sidecar_1.sprites.minigolfCrate,
        ai: 'spider',
        damageMessage: 'spider bite',
        creatureType: 'spider',
        name: 'Spider',
        letter: 'S',
        letterOffset: -3,
        letterOffsetY: 0,
        moveStrength: 0.5,
        isAffectedBySlopes: true,
        enemyDifficulty: 8,
        enemyPoints: 2,
        canBreakCrates: true,
        size: 1,
        damagedSayings: ['chitter', 'scuttle'],
        colorDisc: minigolfColors_1.palApollo.pink200,
        colorLetter: minigolfColors_1.palApollo.red400,
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitSpider],
        hitBySounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitBySpider],
        bleeds: 'slime',
        dropChance: 0.75,
        onDeath: 'drop-item-lesser',
    }),
    enemyTroll: exports.createEnemy({
        density: 10,
        maxHealth: 8,
        hasHealth: true,
        hasDisc: true,
        shape: 'circle',
        frames: sprites_sidecar_1.sprites.minigolfCrate,
        ai: 'chase-player',
        damageMessage: 'crushed',
        creatureType: 'troll',
        name: 'Troll',
        letter: 'T',
        letterOffset: -7,
        moveStrength: 0.66,
        isAffectedBySlopes: true,
        enemyDifficulty: 9,
        enemyPoints: 5,
        size: 1.5,
        canBreakCrates: true,
        damagedSayings: ['grunt', 'roar', 'grumble'],
        colorDisc: minigolfColors_1.palApollo.blue200,
        colorLetter: minigolfColors_1.palApollo.green300,
        contactSounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitTroll],
        hitBySounds: [minigolfSounds_sidecar_1.minigolfSounds.playHitByTroll],
        onDeath: 'drop-item',
        dropChance: 1,
        bleeds: 'blood',
    }),
};
